<div class="mt-5" [formGroup]="formGroup">
  <div class="flex flex-row">
    <span
      class="text-md font-medium mb-5 card-title"
      [ngClass]="{ required: fields.isRequired }"
      >{{ fields.displayName }}</span
    >
  </div>

  <div
    class="grid grid-cols-1 lg:grid-cols-2 gap-5"
    [ngClass]="{ cardScroll: fieldsData?.length > 5 }"
  >
    <div
      class="rounded-xl border p-4 flex items-center justify-between gap-2.5"
      *ngFor="let item of fieldsData"
    >
      <div class="flex items-center gap-3.5">
        <div class="relative size-[47px] shrink-0">
          <div class="relative size-[44px] shrink-0">
            <img
              src="./assets/media/data-view/locations.png"
              class="w-[56px] h-[56px]"
            />
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <span
            class="flex items-center gap-1.5 leading-none font-semibold text-sm text-gray-900"
          >
            {{ item.key }}
          </span>
          <span class="text-2sm text-gray-600 text-wraps">
            {{ item.name }}
          </span>
        </div>
      </div>

      <div class="switch switch-sm">
        <input
          class="radio cursor-pointer"
          [formControlName]="fields.fieldName"
          type="radio"
          [value]="item.key"
          (change)="onToggle(item.key)"
        />
      </div>
    </div>
  </div>
</div>
<div *ngIf="showValidationError" class="text-sm text-danger mt-2">
  Please select an option.
</div>
